import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Card, Col, Row, Button } from 'react-bootstrap';
import { addAuthentication } from '../../../actions/users';
import { usePermission } from '../../../helpers/common';

const UserLoginCard = (props) => {
    const { authProviderInfo, userInfo, setResponse, actions } = props;
    const authIconUrl = authProviderInfo && require(`../../../../assets/images/auth_${authProviderInfo.authentication_provider_name.toLowerCase()}.png`);

    const [authLogin, setAuthLogin] = useState("");
    const [prevAuthLogin, setPrevAuthLogin] = useState("");

    useEffect(() => {
        const filteredList = userInfo.authList ? userInfo.authList.filter(e =>
            e.authentication_provider_id === authProviderInfo.authentication_provider_id) : [];
        const oAuthDetails = filteredList.length > 0 ? filteredList[0] : null;
        if (oAuthDetails && oAuthDetails.authentication_login) {
            const loginId = oAuthDetails.authentication_login ? oAuthDetails.authentication_login : ""
            setAuthLogin(loginId);
            setPrevAuthLogin(loginId);
        }
    }, []);

    const handleChange = (e) => {
        setResponse({ isSuccess: false, message: null });
        const { value } = e.target;
        setAuthLogin(value.length > 0 ? value : "");
    };

    const handleClear = () => {
        setResponse({ isSuccess: false, message: null });
        setAuthLogin("");
    }

    const handleSave = () => {
        setResponse({ isSuccess: false, message: null });

        const params = {
            user_id: userInfo.user_id,
            auth_login: authLogin,
            auth_provider_id: authProviderInfo.authentication_provider_id
        }

        actions.addAuthentication(params, (message, isSuccess) => {
            if (isSuccess) setPrevAuthLogin(authLogin);
            setResponse({ isSuccess, message })
        });
    };

    const isDisable = authLogin === prevAuthLogin;
    const allow = usePermission();
    const isAllowCreate = allow("user", "create") ? true : false;
    const isAllowEdit = allow("user", "edit") ? true : false;

    return <Card className="login-card">
        <Row className="login-detail m-0">
            <Col className="login-logo p-0" lg={2} md={2} sm={2}>
                <img src={authIconUrl} alt="" className="fa-icon" />
            </Col>
            <Col className="login-input p-0">
                <input
                    disabled={!(isAllowCreate || isAllowEdit)}
                    type="email"
                    autoComplete="off"
                    size='sm'
                    placeholder={`${authProviderInfo.authentication_provider_name} login`}
                    name={`${authProviderInfo.authentication_provider_name}`}
                    value={authLogin || ""}
                    onChange={handleChange}
                />
                {authLogin && (isAllowCreate || isAllowEdit) &&
                    <i id={authProviderInfo.authentication_provider_id}
                        className="fa fa-times-circle"
                        aria-hidden="true"
                        title="Clear"
                        onClick={handleClear} />}
            </Col>
            {(isAllowCreate || isAllowEdit) && <Col className="done-btn p-0" lg={2} md={2} sm={2} style={{ textAlign: 'center' }}>
                <Button
                    id={authProviderInfo.authentication_provider_id} size="sm" variant="primary"
                    disabled={isDisable}
                    className={`${isDisable ? "disable" : ""}`}
                    onClick={handleSave}>Done</Button>
            </Col>}
        </Row>
    </Card>
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ addAuthentication }, dispatch)
});

const mapStateToProps = (state, ownProps) => ({
    authProviderInfo: state.users.authProviderListById.payload[ownProps.authId]
});

export default connect(mapStateToProps, mapDispatchToProps)(UserLoginCard);